import { FEATURED_PRODUCTS_PAIR } from '../constants/constants';
import isAllowedTariffForUser from './isAllowedTariffForUser';
import getProductWithAppliedAccount from '../mutators/getProductWithAppliedAccount';

/**
 * Returns tariff to suggest (if is available) as a default pre-selection option (in case of no URL param).
 *
 * @param product
 * @param tariffs
 * @param mainProduct
 * @param [cart]
 * @return {*}
 */
export default (product, tariffs, mainProduct, cart) => {
    let result = null;
    // Clone product in order to avoid mutations there.
    let productInstance = { ... product };
    let mainProductInstance = { ... mainProduct };
    // DB API.
    if (productInstance?.product_id === 2) {
        result = Object.values(tariffs)
            .filter(tariff => !cart || isAllowedTariffForUser({ tariff, product, mainProductInstance, cart, atLeastOnePeriod: true }))
            .sort((a, b) => a?.checks - b?.checks)
            // Refer defaults by a full path of product.product_id.
            .find(tariff => tariff?.checks >= FEATURED_PRODUCTS_PAIR[productInstance.product_id]?.defaults?.tariff_services);
    } else if (productInstance?.product_id === 7) {
        productInstance = getProductWithAppliedAccount(productInstance, cart?.account_id);
        mainProductInstance = getProductWithAppliedAccount(mainProductInstance, cart?.account_id);
        const compareWith = product?.account_projects
            || FEATURED_PRODUCTS_PAIR[product.product_id]?.defaults?.tariff_services;
        result = Object.values(tariffs)
            .filter(tariff => !cart || isAllowedTariffForUser({ tariff, productInstance, mainProductInstance, cart, atLeastOnePeriod: true }))
            .sort((a, b) => a?.projects - b?.projects)
            // Refer defaults by a full path of product.product_id.
            .find(tariff => tariff?.projects >= compareWith);
    }
    return result;
}
